<template>
	<div :id="'Group '+ index" :class="'groupBorder'+index"  class="panel clickable panel-default groupPanel"  :href="'#'+ index + '-content'" data-toggle="">
		<div class="panel-heading" :class="'group'+index" >
			<h2 class="panel-title" >
					<div style="background-color: white;  border-radius: 5px; margin-left: 20px; padding-left: 10px;">
						<a :href="'#'+ index + '-content'" data-toggle="collapse" style="text-overflow:ellipsis; color: rgb(66, 70, 71);">
			              {{ group.group_name }}
			              <button type="button" class="btn btn-xs" :class="index+'-button'" :id="'#'+index+'-button'" style="background:none;float:right;">
			                <span class="glyphicon glyphicon-collapse-down" aria-hidden="true"></span>
			              </button>
			            </a>
			        </div>
			</h2>
			
		</div>
		
		<div class="panel-body" :id="index + '-content'" v-if="group.group_cahid == ''">
			<!-- Inputs -->
			<input type="hidden" :name="'group'+ index +'-hidden'" :id="'group'+ index +'-hidden'"   value="1" />

			<!-- separating the group questions from the hospital questions for hide/show -->
			<div :id="'group'+ index +'-group-questions'">

				<!-- Geography -->
				<div class="row">
					<div class="col-md-8 text-right ">
						<strong>
						{{ getGeo(group.group_geography) }}</strong>
					</div>
					<div class="col-md-4"  v-if="group.group_geography == 'state'">
						<!-- State Geography -->
						 {{ getState(group.group_geography_state) }}
					</div>
					<div class="col-md-4"  v-else-if="group.group_geography == 'region'">
						<!-- Region Geography -->
						 {{ getRegion(group.group_geography_region) }}
					</div>
					<div class="col-md-4"  v-else-if="group.group_geography == 'federal'">
						<!-- Federal Geography -->
						All
					</div>
				</div>

				<!-- Net Patient Revenue -->
				<div class="row">
					<div class="col-md-8 text-right ">
						<strong>
						Net Patient Revenue:</strong>
					</div>
					<div class="col-md-4">
						{{ getRevcat( group.group_netpatrev ) }}
					</div>
				</div>

				<!-- Rural Healthcare Clinic -->
				<div class="row">
					<div class="col-md-8 text-right ">
						<strong>
						Rural Health Clinic:</strong>
					</div>
					<div class="col-md-4">
						{{ getHasrhc(group.group_ruralclinic) }}
					</div>
				</div>

				<!-- Long-Term Care -->
				<div class="row">
					<div class="col-md-8 text-right ">
						<strong>
						Long-Term Care:</strong>
					</div>
					<div class="col-md-4">
						{{ getHassnf(group.group_longtermcare) }}
					</div>
				</div>

				<!-- Government Owned -->
				<div class="row">
					<div class="col-md-8 text-right ">
						<strong>
						Government Owned:</strong>
					</div>
					<div class="col-md-4">
						{{ getGovt(group.group_govtowned) }}
					</div>
				</div>
				<!-- System -->
				<div class="row hide">
					<div class="col-md-8 text-right ">
						<strong>
						System:</strong>
					</div>
					<div class="col-md-4">
						{{ getSystem(group.group_system) }}
					</div>
				</div>

				<!-- Data Year -->
					<div class="row" v-if="chartType === 'bar'" >
						<div class="col-md-8 text-right ">
							<strong>
							Data from Year:</strong>
						</div>
						<div class="col-md-4">
							{{ group.group_year }}
						</div>
					</div>
			</div>
			

		</div>
		<div  class="panel-body" :id="index + '-content'" v-else-if="group.group_cahid != ''"> 
			<!-- CAHID -->
			<div class="row " :id="'group'+ index +'-cahid-div'">
				<div class="col-md-4 ">
					<strong>
					Single Hospital</strong>
				</div>
				
			</div>

			<div class="row" v-if="chartType == 'bar'" >
						<div class="col-md-4 ">
							<strong>
							Data from Year:</strong>
						</div>
						<div class="col-md-4">
							{{ group.group_year }}
						</div>
					</div>

		</div>
		<div v-else>
			BLAH2
		</div>
	</div>

</template>

<script type="module">

</script>

<script setup>
import { defineEmits, ref, defineExpose, onMounted } from "vue";  
import { useVisualizationsStore } from '../../stores/vis_store'
//const emit = defineEmits(["passGroupData"]); 
let props = defineProps(['index', 'chartType', 'years', 'defaultYear', 'user', 'indicator', 'group', ])
const { getRevcat, getGeo, getHasrhc, getHassnf, getGovt, getState, getSystem, getRegion} = useVisualizationsStore()
// const group_name = ref(props.group_name);
// const group-cahid = ref(props.group-cahid);
// const group_geography = ref(props.group_geography);
// const group_geography_region = ref(props.group_geography_region);
// const group_geography_state = ref(props.group_geography_state);
// const group_geography_national = ref(props.group_geography_national);
// const group_netpatrev = ref(props.group_netpatrev);
// const group_ruralclinic = ref(props.group_ruralclinic);
// const group_longtermcare = ref(props.group_longtermcare);
// const group_govtowned = ref(props.group_govtowned);
// const group_system = ref(props.group_system);
// const group_year = ref(parseInt(props.group_year));

	// const getRevcat = (input) => { 
    // 	var ret = "";
    //     switch (input) {
    //         case 0:
    //             ret = 'All';
    //             break;
    //         case 1:
    //             ret = 'Under 10m';
    //             break;
    //         case 2:
    //             ret = '10-20m';
    //             break;
    //         case 3:
    //             ret = 'Over 20m';
    //             break;
    //         default:
    //             ret = "";
    //             break;
    //     }
    //     return ret;
    // };

    // const getGeo = (input) => { 
    // 	var ret = "";
    //     switch (input) {
    //         case 'state':
    //             ret = 'State';
    //             break;
    //         case 'region':
    //             ret = 'Region';
    //             break;
    //         case 'national':
    //             ret = 'National';
    //             break;
    //         default:
    //             ret = "";
    //             break;
    //     }
    //     return ret;
    // };

    // const getHasrhc = (input) => { 
    // 	var ret = "";
    //     switch (input) {
    //         case 0:
    //             ret = 'All';
    //             break;
    //         case 1:
    //             ret = 'No RHC';
    //             break;
    //         case 2:
    //             ret = 'Has RHC';
    //             break;
    //         default:
    //             ret = "";
    //             break;
    //     }
    //     return ret;

    // }


    // const getHassnf = (input) => { 
    // 	var ret = "";
    //     switch (input) {
    //         case 0:
    //             ret = 'All';
    //             break;
    //         case 1:
    //             ret = 'Has LTC';
    //             break;
    //         case 2:
    //             ret = 'No LTC';
    //             break;
    //         default:
    //             ret = "";
    //             break;
    //     }

    //     return ret;
    // }


    // const getGovt = (input) => { 
    //     var ret = "";
    //     switch (input) {
    //         case 0:
    //             ret = 'All';
    //             break;
    //         case 1:
    //             ret = 'Govt';
    //             break;
    //         case 2:
    //             ret = 'Nongovt';
    //             break;
    //         default:
    //             break;
    //     }

    //     return ret;
    // }

    // const getState = (input) => { 
    //     var ret = "";
    //     switch (input) {
    //         case 0:
    //             ret = 'All';
    //             break;
    //         default:
    //         	ret = input;
    //             break;
    //     }

    //     return ret;
    // }

    // const getSystem = (input) => { 
    //     var ret = "";
    //     switch (input) {
    //         case 0:
    //             ret = 'All';
    //             break;
    //         case 1:
    //             ret = 'None';
    //             break;
    //         default:
    //             ret = "";
    //             break;
    //     }

    //     return ret;
    // }

    // const getRegion = (input) => { 
    //     var ret = "";
    //     switch (input) {
    //         case 0:
    //             ret = 'All';
    //             break;
    //         case 1:
    //             ret = 'Northeast';
    //             break;
    //         case 2:
    //             ret = 'Midwest';
    //             break;
    //         case 3:
    //             ret = 'South';
    //             break;
    //         case 4:
    //             ret = 'West';
    //             break;
    //         default:
    //             ret = "";
    //             break;
    //     }

    //     return ret;
    // }

</script>
